"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RelatedCases = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
var window_open_args_1 = require("../case-detail/window-open-args");
var conditional_1 = require("../conditional/conditional");
var case_card_1 = require("../case-card/case-card");
var getChildWindowParams = ui_common_1.caseUtils.getChildWindowParams;
var RelatedCases = function (_a) {
    var _b = _a.relatedCases, relatedCases = _b === void 0 ? [] : _b, _c = _a.showLoading, showLoading = _c === void 0 ? false : _c, activeItem = _a.activeItem, onOpenRelatedCase = _a.onOpenRelatedCase, showProviderInfo = _a.showProviderInfo, rest = __rest(_a, ["relatedCases", "showLoading", "activeItem", "onOpenRelatedCase", "showProviderInfo"]);
    var styleClasses = [
        'related-cases',
        {
            'bg-loaded': !showLoading,
            'bg-with-cases': !!(relatedCases === null || relatedCases === void 0 ? void 0 : relatedCases.length),
            'bg-empty': !showLoading,
            'bg-show-loading': showLoading
        }
    ];
    var handleRowSelection = function (relatedCase) {
        if (!!relatedCase) {
            var childWindowParams = getChildWindowParams(relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.case_uid, relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.process_instance_guid, relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.service_line, window_open_args_1.launchAmplifyCase);
            onOpenRelatedCase(childWindowParams);
        }
    };
    // Preparing the case list to identify the current case run
    var relatedCaseList = relatedCases.map(function (caseRun) {
        var row = {
            isCurrent: caseRun.case_id === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id) &&
                caseRun.process_instance_guid === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.process_instance_guid),
            id: caseRun.case_id + '-' + caseRun.process_instance_guid,
            caseRun: __assign(__assign({}, caseRun), { date_of_service: ui_common_1.cmxDateTime.format(caseRun.date_of_service, ui_common_1.cmxDateTime.FORMATS.DATE_OF_SERVICE) })
        };
        return row;
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, rest, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [!showLoading, !(relatedCaseList === null || relatedCaseList === void 0 ? void 0 : relatedCaseList.length)] }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "empty-content" }, { children: "There are no other related cases at this time." })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [showLoading] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "loading-container" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.LoadingSlugs, { numberItems: 3 }, "loading-slugs") })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ every: [!showLoading, !!(relatedCaseList === null || relatedCaseList === void 0 ? void 0 : relatedCaseList.length)], displayMode: "flex" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "related-table" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "grid-container" }, { children: relatedCaseList === null || relatedCaseList === void 0 ? void 0 : relatedCaseList.map(function (relatedCase, idx) {
                            return ((0, jsx_runtime_1.jsx)(case_card_1.CaseCard, { caseData: relatedCase.caseRun, isCurrent: relatedCase.isCurrent, onCaseClick: handleRowSelection, showProviderInfo: showProviderInfo, currentCaseTenantCode: activeItem === null || activeItem === void 0 ? void 0 : activeItem.facility, currentCaseTenantName: activeItem === null || activeItem === void 0 ? void 0 : activeItem.tenant_name }, idx));
                        }) })) })) }))] })));
};
exports.RelatedCases = RelatedCases;
RelatedCases.displayName = 'RelatedCases';
//# sourceMappingURL=related-cases.js.map